import React, {useContext, useEffect, useRef, useState} from "react";
import FiltersBar from "./FiltersBar";
import SortDrawer from "./SortDrawer";
import OfferList from "./OfferList";
import MetaTagsManipulator from "../../utils/MetaTagsManipulator";
import UrlDecorator from "../../utils/UrlDecorator";
import URLSearchParamsConverter from "../../utils/URLSearchParamsConverter";
import {useLocation, withRouter} from "react-router";
import {goVehisService} from "../../utils/axios";
import {CustomerTypeContext} from "../../context/customer-type-context";
import {SearchOptionsContext} from "../../context/search-options-context";
import ExpertHelp from "../HomePage/ExpertHelp";
import HomeNewsletter from "../HomePage/HomeNewsletter";

const DRAFT_STORAGE_KEY = "offerListFiltersDraft";

function OfferListPage(props) {

    MetaTagsManipulator.setTitle("Lista ofert");
    MetaTagsManipulator.setDescription("Lista ofert");

    UrlDecorator.addSellerCode();

    const [isSortDrawerOpen, setIsSortDrawerOpen] = useState(false);
    const [offerViewType, setOfferViewType] = useState("grid-view");
    const [offersNumber, setOffersNumber] = useState("...");

    const customerContextType = useContext(CustomerTypeContext)[0];

    const initialState = {
        brands: [],
        models: [],
        bodyTypes: [],
        fuelTypes: [],
        segments: [],
        installmentNetFrom: "",
        installmentNetTo: "",
        installmentGrossFrom: "",
        installmentGrossTo: "",
        minimumSellPriceNetFrom: "",
        minimumSellPriceNetTo: "",
        minimumSellPriceGrossFrom: "",
        minimumSellPriceGrossTo: "",
        mileageFrom: "",
        mileageTo: "",
        manufactureYearFrom: "",
        manufactureYearTo: "",
        enginePowerHpFrom: "",
        enginePowerHpTo: "",
        engineCapacityFrom: "",
        engineCapacityTo: "",
        gearboxTypes: [],
        driveTypes: [],
        colors: [],
        numberOfDoors: [],
        numberOfSeats: [],
        equipment: [],
        availability: false,
        specialOffer: false,
        isPremium: false,
        vehicleTypes: "OSOBOWE",
        newUsed: "all",
        calculationTypes: [],
        nip: "",
        createdFrom: "",
        createdTo: "",
        sources: []
    };

    const restoredFromDraftRef = useRef(false);

    const [searchParameters, setSearchParameters] = useState(() => {
        try {
            const stored = JSON.parse(sessionStorage.getItem(DRAFT_STORAGE_KEY));
            if (stored && stored.search === props.location.search) {
                restoredFromDraftRef.current = true;
                return stored.params;
            }
        } catch (e) {
            // corrupted/old draft — ignore and fall through to initialState
        }
        return initialState;
    });

    const location = useLocation();

    const searchOptions = useContext(SearchOptionsContext);

    useEffect(() => {
        // A back/forward navigation to /lista-ofert remounts this page from
        // scratch, so without this the filter picks a user made but never
        // clicked "Zastosuj filtry" for (e.g. checking a brand box) would be
        // silently lost — the URL never changed, so it can't be recovered
        // from it. We restore them from sessionStorage instead, but only
        // when the URL is exactly what it was when we saved them: otherwise
        // (a fresh visit, a shared link with different filters) the URL
        // should win.
        if (restoredFromDraftRef.current) return;
        if (!searchOptions) return;

        setSearchParameters(
            URLSearchParamsConverter.getSearchParamsFromURLSearchString(props.location.search, searchOptions)
        );
    }, [searchOptions]);

    useEffect(() => {
        sessionStorage.setItem(DRAFT_STORAGE_KEY, JSON.stringify({
            search: props.location.search,
            params: searchParameters
        }));
    }, [searchParameters]);

    useEffect(() => {
        const urlSearchParams = new URLSearchParams(props.location.search);
        urlSearchParams.set("limit", "1000000");
        urlSearchParams.set("customerType", customerContextType);
        urlSearchParams.delete("page");

        goVehisService.get("/vehicles/count?" + urlSearchParams).then(response => {
            setOffersNumber(parseInt(response.data, 10) || 0);
        });
    }, [props.location.search, customerContextType]);

    return (
        <div className="lista-ofert">

            <SortDrawer
                isOpen={isSortDrawerOpen}
                title="Wybierz sortowanie"
                onClose={() => setIsSortDrawerOpen(false)}/>

            <FiltersBar
                offersNumber={offersNumber}
                viewType={offerViewType}
                onViewTypeChange={(viewType) => setOfferViewType(viewType)}
                sortClicked={() => setIsSortDrawerOpen(true)}
                setSearchParameters={(params) => setSearchParameters(params)}
                searchParameters={searchParameters}
                initialState={initialState}/>

            <OfferList
                viewType={offerViewType}
                offersNumber={offersNumber}
                setSearchParameters={(params) => setSearchParameters(params)}
                searchParameters={searchParameters}/>

            <ExpertHelp/>
            <HomeNewsletter/>

        </div>
    );
}

export default withRouter(OfferListPage);
